// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-height[data-v-2b968934] {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body[data-v-2b968934] {\n  padding-top: 15px !important;\n}", ""]);
// Exports
module.exports = exports;
